<template>
    <div class="container-login">
        <!--  <header>
            <img src="@/assets/images/logo-tecmor.jpg" alt="">
        </header> -->
       
        <div class="container-cards">
            <div class="title-login"></div>
            
            <v-card width="500px" :elevation="8">
                <div class="pa-8">
                    <div class="text-center">
                        <img src="@/assets/images/logo-adc.jpeg" alt="Login" class="icon-login">
                    </div>
                    <div class="title">Iniciar Sesión</div>

                    <v-form @submit.prevent>
                        <v-text-field
                            label="Usuario"
                            variant="outlined"
                            v-model="formGroup.data.username"
                            :rules="formGroup.rules.username"
                            @keyup.enter="login()"
                            class=" mb-2"
                        >
                            <template #prepend-inner>
                                <img src="@/assets/images/user.jpg" alt="" width="30">
                            </template>
                        </v-text-field>

                        <v-text-field
                            label="Contraseña"
                            variant="outlined"
                            v-model="formGroup.data.password"
                            :rules="formGroup.rules.password"
                            @keyup.enter="login()"
                            class="mb-2"
                            :type="visible ? 'text' : 'password'"
                            @click:append-inner="visible = !visible"
                            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
                        >
                            <template #prepend-inner>
                                <img src="@/assets/images/password.jpg" alt="" width="30">
                            </template>
                        </v-text-field>

                        <v-btn 
                            block 
                            size="large" 
                            class="btn-login text-none" 
                            :disabled="validateForm() || isLoading"
                            :loading="isLoading"
                            v-on:click="login()">
                            Iniciar Sesión
                        </v-btn>

                    </v-form>
                </div>
            </v-card>

            <div class="vid-div">                
                <img src="@/assets/videos/intro.gif" class="video">            
            </div>
            <AlertComponent :value="dialogData"/>
            <SnackbarComponent :value="snackbarData"/>
        </div>
        <Footer />
    </div>
</template>

<script>
    import { useManagementCatalogStore } from '@/stores/managementCatalog'
    import { TWO_FA_STATUS, useAuthStore } from '@/stores/auth'
    import { LoginService } from '@/services/LoginService'
    import AlertComponent from '@/components/Alert.vue'
    import SnackbarComponent from '@/components/Snackbar.vue'
    import Footer from '@/components/Footer.vue'
    import { useUiStore } from '@/stores/ui'
    
    export default {
        name: 'LoginView',
        props: {
            msg: String
        },
        components: {
            Footer,
            AlertComponent,
            SnackbarComponent,
        },
        data: () => ({
            formGroup: {
                data: {
                    username: '',
                    password: '',
                },
                rules: {
                    username: [
                        value => {
                            if (value) {
                                return true;
                            }
                            return 'El campo Usuario es obligatorio'
                        }
                    ],
                    password: [
                        value => {
                            if (value) {
                                return true;
                            }
                            return 'El campo Contraseña es obligatorio'
                        }
                    ],
                },
            },
            
            dialogData: { 
                openDialog: false,
                title: '',
                description: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            isLoading: false,
            visible: false,           
        }),
        methods: {
           
            login: async function () {
                const authStore = useAuthStore();

                if (this.validateForm()) {
                    return;
                }
                this.isLoading = true;

                const formData = new FormData();
                formData.append("username", this.formGroup.data.username);
                formData.append("password", this.formGroup.data.password);

                await LoginService.login(formData).then((responseData) => {                    
                    if (!responseData.error) {                        
                        localStorage.setItem('TIPO', responseData.response.tipo)
                        localStorage.setItem('TOKEN', responseData.response.token)
                        localStorage.setItem('DESPACHO', responseData.response.despacho)
                        localStorage.setItem('USERNAME', responseData.response.username)
                        localStorage.setItem('NAME', responseData.response.name)
                        localStorage.setItem('LAST_NAME', responseData.response.last_name)
                        localStorage.setItem('ID', responseData.response.id)
                        localStorage.setItem('PERMISOS', responseData.response.permisos)
                        localStorage.setItem('TIPO_CARTERA', responseData.response.tipo_cartera)
                        useManagementCatalogStore().seedPolicy(responseData.response.management_catalog_policy, responseData.response.despacho)

                        const uiStore = useUiStore()
                        uiStore.cargarVocabulario()

                        this.snackbarData.description = "¡Inicio de Sesión Exitoso!";
                        this.snackbarData.openSnackbar = true;
                        authStore.isAuthenticated = true;
                        // Redirigir a la configuracion o validacion de 2FA si es necesario
                        if(responseData.response.requires_2fa){
                            const twoFAStatus = responseData.response.is_2fa_setup
                                ? TWO_FA_STATUS.SETUP
                                : TWO_FA_STATUS.REQUIRES_SETUP;
                            authStore.setTwoFAStatus(twoFAStatus);
                            this.$router.push({ name: responseData.response.redirect_route_name });
                        } else {
                            authStore.setTwoFAStatus(TWO_FA_STATUS.NO_REQUIRED);
                            const ISABELLE_PHONE = sessionStorage.getItem('ISABELLE_PHONE')
                            if (ISABELLE_PHONE !== null && ISABELLE_PHONE !== undefined && ISABELLE_PHONE !== '') {
                                this.$router.push(`/SGCCV/managementIsabelle/${ISABELLE_PHONE}`);
                            } else {
                                this.$router.push('/SGCCV');
                            }
                        }

                    } else {
                        this.dialogData = {
                            openDialog: true,
                            title: 'Ocurrió un Problema',
                            description: responseData.msg,
                        }
                    }
                });

                this.isLoading = false;
            },
            validateForm: function () {
                let username = this.formGroup.data.username
                let password = this.formGroup.data.password

                const validate = (username === '' || password === '')
                return validate
            }
        }
    }
</script>

<style scoped>
    .container-login {
        height: 100vh;
        background-image: url("@/assets/images/background.jpg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    .title-login {
        font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
        line-height: 1.2;
        font-size: 25pt;
        font-weight: 400;
        padding-bottom: 20px;
    }
    .container-cards {
        padding-top: 7%;
        padding-left: 1%;        
        display: flex;
        justify-content: center;
        height: 95vh;
    }
    .icon-login {
        height: 90px;
    }
    .title {
        text-align: center;
        font-size: 20px;
    }
    form {
        margin: 30px 0 10px 0;
    }
    .btn-login {
        background-color: #007BFF;
        color: #FFFFFF;
    }
    footer {
        height: 5vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .loading {
        text-align: center;
    }

    .vid-div{
        padding: 3%;
        width: 50%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .video{
        max-width: 120%;
        max-height: 100%;
        padding-left: 10%;
        width: 120%;
        height: 100%;
    }

   
</style>
